/** Tasks: free tasks and tasks about an asset, an edit or a collection, with their notes. */

export type TaskStatus = 'open' | 'in_progress' | 'done' | 'cancelled';
export const TASK_STATUS_LABELS: Record<TaskStatus, string> = { open: 'To do', in_progress: 'In progress', done: 'Done', cancelled: 'Cancelled' };

export interface TaskDTO {
  id: string;
  title: string;
  details: string;
  status: TaskStatus;
  /** What the task is about: an asset, an edit (sequence) or a collection; null for a free task. */
  subject: { type: 'asset' | 'sequence' | 'collection'; id: string; name: string; link: string } | null;
  /** A person, an access group, or (1.0.0-rc.9) a role: every member of a group or role sees the task as theirs. */
  assignee: { type: 'user'; id: string; name: string } | { type: 'group'; id: string; name: string } | { type: 'role'; id: string; name: string } | null;
  /** A task someone took from a role or group (1.0.0-rc.9, Take it): where Give back returns it. */
  takenFrom: { type: 'group' | 'role'; id: string; name: string } | null;
  dueAt: string | null;
  overdue: boolean;
  createdBy: { id: string; name: string } | null;
  createdAt: string;
  updatedAt: string;
  completedAt: string | null;
  completedBy: string | null;
  notes: number;
  /** What the caller may do with it. */
  canEdit: boolean;
  canChangeStatus: boolean;
  /** A role or group task the caller is a member of: Take it assigns it to them (1.0.0-rc.9). */
  canTake: boolean;
  /** The caller took it from a role or group: Give back returns it there. */
  canGiveBack: boolean;
}

/** Whom a task can be assigned to (GET /api/v1/tasks/assignees): people, roles (1.0.0-rc.9) and access groups. */
export interface TaskAssigneesDTO {
  people: Array<{ id: string; name: string }>;
  roles: Array<{ key: string; name: string; members: number }>;
  groups: Array<{ id: string; name: string; members: number }>;
}

export interface TaskNoteDTO {
  id: string;
  author: string | null;
  body: string;
  statusTo: TaskStatus | null;
  createdAt: string;
  /** Written by the person reading (0.99.1). */
  mine: boolean;
}
